export const ERROR_GENERIC = 'An error occurred!  Please try again and reach \
  out to support@bookpeazy.com if the issue persists.';
export const SUPPORT_EMAIL = 'support@bookpeazy.com';
export const BookingError = 'Please ensure you filled out the form and your \
selected time is still available.';
export const LocationFormError = 'Please ensure you filled out the form.';

